import React from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useTheme } from "../ThemeContext/ThemeContext.js";

const PageLoading = () => {
  const { colors } = useTheme();
    <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={90} thickness={3} sx={{ color: colors.primary.main }} />
      </Box>
};

export default PageLoading;
